import { createSlice } from '@reduxjs/toolkit';

interface initState {
  videoDerive: string[];
  videoInfo: {
    docsName: string | undefined;
    videoUrl: string | undefined;
    duration: string;
  };
  sizeType: {
    size: string | undefined;
    type: string | undefined;
  };
  recognitionType: string;
  draftVideoInfo: {
    id: number;
    videoName: string;
    videoUrl: string;
    videoDuration: string;
  };
  uploadCreatImg: string;
}

const initialState: initState = {
  videoDerive: [],
  videoInfo: {
    docsName: undefined,
    videoUrl: undefined,
    duration: '',
  },
  sizeType: {
    size: undefined,
    type: undefined,
  },
  recognitionType: '', // ai换脸的操作类型 handle or ai
  draftVideoInfo: {
    id: 0,
    videoName: '',
    videoUrl: '',
    videoDuration: '',
  },
  uploadCreatImg: '', // ai视频中图生视频情况下生成中的img底图记录
};

export const faceSwapSlice = createSlice({
  name: 'faceSwap',
  initialState,
  reducers: {
    setVideoDerive: (state, action) => {
      state.videoDerive = action.payload;
    },
    setVideoInfo: (state, action) => {
      state.videoInfo = action.payload;
    },
    setSizeType: (state, action) => {
      state.sizeType = action.payload;
    },
    setRecognitionType: (state, action) => {
      state.recognitionType = action.payload;
    },
    setDraft: (stage, action) => {
      stage.draftVideoInfo = action.payload;
    },
    setUploadCreatImg: (stage, action) => {
      stage.uploadCreatImg = action.payload;
    },
  },
});
// 每个 case reducer 函数会生成对应的 Action creators
export const {
  setVideoDerive,
  setVideoInfo,
  setSizeType,
  setRecognitionType,
  setDraft,
  setUploadCreatImg,
} = faceSwapSlice.actions;

export default faceSwapSlice.reducer;
